export default "__VITE_ASSET__SkU3467K__"